import BackgroundProcessModel from 'models/background-process.model';
import backgroundProcessServices from 'services/backgroundProcessServices';

export const processesActions = {
  searchProcess: 'searchProcess',
};

export default {
  [processesActions.searchProcess]: {
    saga: function*({ payload = {} }) {
      const { callbacks, body = {} } = payload;
      try {
        const parseBody = BackgroundProcessModel.parseRequestSearch(body);
        const response = yield backgroundProcessServices.search(parseBody);
        callbacks && callbacks.onSuccess(response);
      } catch (error) {
        callbacks && callbacks.onFailed(error);
      }
    },
  },
};
